import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { ProductSearchForm } from './ProductSearchForm'
import { ProductTableUI } from './ProductTableUI'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class ProductTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetProductReport?offset=";
    this.getExcelUrl = "/api/v1/GetProductReportExcel";
    this.className = "ProductReport";
    this.state.mode = "table";
    this.state.searchData = {};

    this.getinitilizedata=false;

  }


  render() {
    //  if (!this.state.isLoaded) {
    //  return <div className="box-body"> در حال بارگذاری</div>;
    // }

    //console.log()
    return (
      <div className="container">
        <ProductSearchForm onSubmit={this.onSubmitSearchData} onExcelClick={this.onExcelButtonClick} searchData={this.state.searchData} />
    
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/product/ProductTable.js